module.exports = "<!-- <div class=\"sidebar-footer\"></div> -->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/app-sidebar/app-sidebar-footer/app-sidebar-footer.component.html
// module id = ./src/app/shared/components/app-sidebar/app-sidebar-footer/app-sidebar-footer.component.html
// module chunks = main